import "react-loading-skeleton/dist/skeleton.css";

import type { Profile } from "@/core/types";
import type { UUID } from "@/core/types";
import { usePatientConsents } from "@/lib/queries/usePatientConsents";

import MemberProfileConsentList from "../MemberProfileConsentList";
import MemberProfilePolicyList from "../MemberProfilePolicyList";
import { MemberProfileACPSection } from "../MemberProfileACPSection/MemberProfileACPSection";

import { MemberProfileConsentsSectionSkeleton } from "./MemberProfileConsentsSectionSkeleton";

type MemberProfileConsentsSectionProps = {
  patientId: UUID;
  patientGroupType?: Profile["group_type"];
  insuranceCarrier: string;
};

export function MemberProfileConsentsSection({
  patientId,
  insuranceCarrier,
  patientGroupType,
}: MemberProfileConsentsSectionProps) {
  const { data: consents, isLoading } = usePatientConsents(patientId);

  const isTeensAndKidsProgram = patientGroupType === "teens_kids_program";

  if (isLoading || !consents) return <MemberProfileConsentsSectionSkeleton />;

  return (
    <>
      {!isTeensAndKidsProgram && (
        <MemberProfileACPSection consents={consents} insuranceCarrier={insuranceCarrier} />
      )}
      <MemberProfilePolicyList consents={consents} patientId={patientId} />
      <MemberProfileConsentList consents={consents} patientId={patientId} />
    </>
  );
}
